import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './baseQuery';

export const emptyApiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'BusinessInfo',
    'BusinessInsights',
    'Metrics',
    'UserInfo',
    'Health',
    'Sandbox',
    'VisibilityRules',
    'VisibilityScore',
    'VisibilityRecommendations',
    'TargetAudience',
    'GeographicFocus',
    'BusinessAddress',
    'BusinessName',
    'Pricing',
    'VisionMode',
    'Subscriptions',
    'Offerings',
    'ExportConfig',
    'Billing',
    'BillingTransactions',
    'CurrentSpend',
    'UserType',
  ],
  endpoints: () => ({}),
});
